import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { useDispatch } from 'react-redux';
import { slice as authSlice, } from "../store/slices/auth";
import { useCommonService } from './useCommonService.ts';

export const useErrorHandler = (props) => {
  const dispatch = useDispatch();
  const commonService = useCommonService()
  return (operation) => catchError((error) => {
    commonService.stopLoading();
    dispatch(authSlice.actions.updateToast({ severity: "error", message: `Failed to ${operation} : ${error?.response?.data?.error}` }));
    return of(null);
  });
};